module.exports = __webpack_public_path__ + "img/icon-arrow-lisst.65164687.svg";